import { useState } from "react";
import { CourseIndexHomeWorkRow } from "components/molecules/CourseIndexHomeWorkRow";
import { DrillModal } from "components/organisms/TabClassHomeWork";
 
import { useAppDispatch } from "hooks";
import "./index.scss";
import { useLazyGetCourseIndexQuery } from "services/courseIndex";
import { decodeToken } from "utils/functions/decodeToken";
import { formatToLocalDate } from "utils/functions/formatToLocalDate";
import { openExternalUrl } from "utils/functions/openExternalUrl";
import { getDrillSmartOnStartDrill } from "utils/functions/getDrillSmartOnStartDrill";
import { useDrillSmart } from "hooks/useDrillSmart";
import { getRowDisplayForWork, type DrillSmartModalData } from "utils/functions/drillSmart";
import {
  useGetCourseworkQuery,
  useGetOverallProgressQuery,
  useGetTestScoresAndPerformanceQuery,
} from "services/homeApi";
import { useSegmentReFetch } from "context";
import { getObjectKeysByValue } from "services/helpers";
import { getTimeFilterInput } from "utils/functions/getTimeFilterInput";
import {
  reStructureSegment,
  replaceArrayOfObjects,
} from "utils/functions/courseWorkReStructure";
import { DrillSmartModal, RefreshModal } from "components/molecules";
import { useScreenSize } from "hooks";
import { DASHBOARD_PROGRAME, MCAT_TEST_TYPE, MOBILE_WIDTH, SELF_PACED_PROGRAME } from "utils/constants";
import { useNavigate } from "react-router-dom";
import { UnlockModal } from "../SelfPacedHomeworkTab/UnlockModal";
import {
  replaceSelfPacedArrayOfObjects,
  reStructureSelfPacedSegment,
} from "utils/functions/selfPacedCourseWorkRestructure";
import { useLazyGetStudyPlannerEventsQuery } from "services/studyPlanner";
import { useLazyGetAiRecommendationsQuery } from "services/aiRecommendations";
import { DrillPaginationTab } from "../SelfPacedHomeworkTab/DrillPaginationTab";

interface IProps {
  isBtn?: boolean;
  isSecondBtn?: boolean;
  secondBtnLabel?: string;
  isMobile: boolean;
  exams: any;
  type: any;
  theme: "light" | "dark";
  title?: string;
}

export const CourseIndexTabClassHomeWork = ({
  exams,
  type,
  theme,
  title,
}: IProps) => {
  const [openUpdateModalState, setOpenUpdateModalState] = useState<any>({
    isOpen: false,
    data: null,
  });

  const [refreshModalStatus, setRefreshModalStatus] = useState({
    isOpen: false,
    contentObjectType: "",
  });
  const drillSmart = useDrillSmart();
  // Score report modal now managed by Redux global state
  const dispatch = useAppDispatch();

  const [toggleUnlockModal, settoggleUnlockModal] = useState(false);

  const navigate = useNavigate();

  const screen = useScreenSize();

  const payload = decodeToken();

  const userId = payload ? payload.userid : null;
  const productCode = payload ? payload.productcode : null;
  const offeringCode = payload ? payload.offeringcode : null;

  const isSelfPaced =
    payload &&
    payload.hasOwnProperty("programtype") &&
    payload.programtype === SELF_PACED_PROGRAME;

  const isDashboard =
    payload &&
    payload.hasOwnProperty("programtype") &&
    payload.programtype === DASHBOARD_PROGRAME;
    
  const testtype =
    payload && payload.hasOwnProperty("testtype") && payload.testtype;

  const {
    refetch: overAllProgressRefetch,
    isFetching: overAllProgressIsFetching,
  } = useGetOverallProgressQuery({
    Userid: userId,
    Productcode: productCode,
    Offeringcode: offeringCode,
  });

  const [ triggerStudyPlannerRefetch, studyPlannerRefetchResult ] =
    useLazyGetStudyPlannerEventsQuery();

  const { data, setData, selectedBtn, selectedSession, subject } = useSegmentReFetch();

  const [courseworkPage, setCourseWorkPage] = useState(1);

  const [ triggerCourseIndexRefetch, refetchCourseIndexIsResult ] =
  useLazyGetCourseIndexQuery();

  const { refetch: testScoresRefetch, isFetching: testScoresIsFetching } =
    useGetTestScoresAndPerformanceQuery();

  const [
    triggerRefetchAiRecommendation,
    aiRecommendationRefetchResult,
  ] = useLazyGetAiRecommendationsQuery();

  const { refetch: courseWorkRefetch, isFetching: courseWorkIsFetching } =
    useGetCourseworkQuery({
      page: courseworkPage,
      ...(isDashboard
        ? {
            selectedOption: parseInt(
              getObjectKeysByValue(selectedBtn, true)[0],
              10
            ),
          }
        : {}),
      ...(isDashboard
        ? {
            timeFilter:
              selectedSession === null
                ? 1
                : getTimeFilterInput(Object.values(selectedSession)[0]),
          }
        : {}),
      ...(isSelfPaced && testtype === MCAT_TEST_TYPE ? {
        subject: subject
      } : {})
    });

  // const matchBtnLabel: any = (type: any, status: any, work: any) => {
  //   if (type === "Prework") {
  //     if (work.ContentObjectType === "Drill") {
  //       if (status === "Not Started") {
  //         return "Start Drill";
  //       } else if (status === "In Progress") {
  //         return "Resume";
  //       } else if (status === "Complete" || status === "Completed") {
  //         return "Retake Drill";
  //       }
  //     } else if (work.ContentObjectType === "Articulate") {
  //       if (status === "Not Started") {
  //         return "Start Lesson";
  //       } else if (status === "In Progress") {
  //         return "Resume";
  //       } else if (status === "Complete" || status === "Completed") {
  //         return "Restart Lesson";
  //       }
  //     } else if (work.ContentObjectType === "Video") {
  //       if (status === "Not Started") {
  //         return "Start Lesson";
  //       } else if (status === "In Progress") {
  //         return "Resume";
  //       } else if (status === "Complete" || status === "Completed") {
  //         return "Restart Lesson";
  //       }
  //     } else if (status === "Not Started") {
  //       return "Update Status";
  //     } else if (status === "In Progress") {
  //       return "Update Status";
  //     } else {
  //       return "Update Status";
  //     }
  //   } else if (type === "Class") {
  //     if (status === "Not Started") {
  //       return "Start Lesson";
  //     } else if (status === "In Progress") {
  //       return "Resume";
  //     } else if (status === "Complete" || status === "Completed") {
  //       return "Restart Lesson";
  //     }
  //   } else if (type === "Homework") {
  //     if (work.ContentObjectType === "Drill") {
  //       if (status === "Not Started") {
  //         return "Start Drill";
  //       } else if (status === "In Progress") {
  //         return "Resume";
  //       } else if (status === "Complete" || status === "Completed") {
  //         return "Retake Drill";
  //       }
  //     } else if (
  //       work.ContentObjectType === "OfflineDrill" ||
  //       work.ContentObjectType === "OfflineReading"
  //     ) {
  //       return "Update Status";
  //     } else if (status === "Not Started") {
  //       return "Start Homework";
  //     } else if (status === "In Progress") {
  //       return "Resume";
  //     } else if (status === "Complete" || status === "Completed") {
  //       return "Restart Homework";
  //     }
  //   } else if (type === "Diagnostic") {
  //     if (work.ContentObjectType === "PairedDrill") {
  //       if (status === "Not Started") {
  //         return "Start Diagnostic Exam";
  //       } else if (status === "In Progress") {
  //         return "Resume";
  //       } else if (status === "Complete" || status === "Completed") {
  //         return "Restart Diagnostic Exam";
  //       }
  //     } else if (status === "Not Started") {
  //       return "Start Diagnostic Exam";
  //     } else if (status === "In Progress") {
  //       return "Resume";
  //     } else if (status === "Complete" || status === "Completed") {
  //       return "Restart Diagnostic Exam";
  //     }
  //   }
  //   return "default button";
  // };

  const handleUpgradeCourse = () => {
    if (payload && payload.hasOwnProperty("freeToPaidUpgradeLink")) {
      window.open(payload.freeToPaidUpgradeLink, "__blank");
      setTimeout(() => {
        settoggleUnlockModal(false);
        setRefreshModalStatus((prev) => ({
          ...prev,
          isOpen: true,
          contentObjectType: "Purchase",
        }));
      }, 500)
    }
  };

  const handleModalClose = () => {
    setRefreshModalStatus((prev) => ({
      ...prev,
      isOpen: false,
      contentObjectType: "",
    }));
  };

  const handleSetCourseworkPage = () => {
    let selectedSegment: any = undefined;
    if (isSelfPaced) {
      selectedSegment =
        data &&
        Array.isArray(data) &&
        data.filter((item) => item.LearningTrackName === title);
    } else {
      selectedSegment =
        data &&
        Array.isArray(data) &&
        data.filter((item) => item.Description === title);
    }
    if (
      selectedSegment &&
      Array.isArray(selectedSegment) &&
      selectedSegment[0] &&
      selectedSegment[0].page
    ) {
      setCourseWorkPage((prev) => selectedSegment[0].page);
    }
  };

  const handlePrimaryButtonClick = (work: any) => {
    if (drillSmart.isDrillSmartGrouping(work)) {
      // Check if DrillSmartGrouping is locked
      if (work.IsLocked === true) {
        if (screen.width <= MOBILE_WIDTH) {
          navigate("/self-paced/unlock");
        } else {
          settoggleUnlockModal(true);
        }
        return;
      }
      drillSmart.openModal(work);
      return;
    }
    if (work.Status === "Lock" || work.IsLocked === true) {
      if (screen.width <= MOBILE_WIDTH) {
        navigate("/self-paced/unlock");
      } else {
        settoggleUnlockModal(true);
      }
    } else if (
      work.ContentObjectType === "OfflineDrill" ||
      work.ContentObjectType === "OfflineReading"
    ) {
      setOpenUpdateModalState((prev: any) => ({
        ...prev,
        isOpen: true,
        data: work,
      }));
      handleSetCourseworkPage();
    } else {
      openExternalUrl({
        url: work.LaunchUrl,
        contentObjectType: work.ContentObjectType,
        testType: testtype,
        dispatch,
        onRefreshModalOpen: (contentType) => {
          handleSetCourseworkPage();
          setRefreshModalStatus((prev) => ({
            ...prev,
            isOpen: true,
            contentObjectType: contentType || "Test",
          }));
        },
      });
    }
  };

  const handleSecondaryButtonClick = (work: any) => {
    if (work.ScoreReportUrl !== null) {
      openExternalUrl({
        url: work.ScoreReportUrl,
        title: "Score Report",
        testType: testtype,
        dispatch,
      });
    }
  };

  // handleScoreReportModalClose no longer needed - handled by Redux global state

  // const handleDisplayOfButtonGroups = (
  //   type: string | undefined,
  //   value: any,
  //   buttonGroup?: string
  // ) => {
  //   if (buttonGroup === "group") {
  //     if (type === "Prework" || type === "Homework") {
  //       if (
  //         value.ContentObjectType === "OfflineDrill" ||
  //         value.ContentObjectType === "OfflineReading"
  //       ) {
  //         if (value.Status === "Completed" || value.Status === "Complete") {
  //           return true;
  //         } else {
  //           return false;
  //         }
  //       } else {
  //         return false;
  //       }
  //     } else {
  //       return false;
  //     }
  //   } else if (buttonGroup === "second") {
  //     if (type === "Prework" || type === "Homework") {
  //       if (
  //         value.ContentObjectType === "Articulate" ||
  //         value.ContentObjectType === "Video"
  //       ) {
  //         return false;
  //       } else if (
  //         value.Status === "Completed" ||
  //         value.Status === "Complete"
  //       ) {
  //         return true;
  //       }
  //     } else if (type === "Class") {
  //       return false;
  //     } else if (value.Status === "Completed" || value.Status === "Complete") {
  //       return true;
  //     }
  //   } else {
  //     return true;
  //   }
  // };

  const handleUpdateModalClose = () => {
    setOpenUpdateModalState((prev: any) => ({
      ...prev,
      isOpen: false,
      data: null,
    }));
  };

  const handleRefreshCourseIndex = async () => {
    const promises = [
      courseWorkRefetch(),
      triggerCourseIndexRefetch(),
      overAllProgressRefetch(),
      testScoresRefetch(),
      triggerRefetchAiRecommendation(),
      ...(isDashboard ? [triggerStudyPlannerRefetch()] : []),
    ];

    Promise.allSettled(promises).then((responses: any) => {
      handleModalClose();
      if (responses[0].status === "fulfilled") {
        try {
          if (isSelfPaced) {
            const deStructuredArray = reStructureSelfPacedSegment(
              responses[0].value.data
            );
            const updatedArray = replaceSelfPacedArrayOfObjects(
              deStructuredArray,
              data
            );
            setData([...updatedArray]);
          } else {
            const deStructuredArray = reStructureSegment(responses[0].value.data);
            const updatedArray = replaceArrayOfObjects(deStructuredArray, data);
            setData([...updatedArray]);
          }
        } catch (_) {
          // keep modal closed; data update failed
        }
      }

      drillSmart.reSyncModalData((groupName) => {
        if (!groupName || responses[1]?.status !== "fulfilled") return null;
        const courseIndexData = responses[1].value?.data;
        const parentNodes = courseIndexData?.ParentNodes ?? [];
        for (const node of parentNodes) {
          const learningTracks = node.LearningTracks ?? [];
          for (const lt of learningTracks) {
            const drillSmartContent = lt.DrillSmartContent ?? lt.drillSmartContent ?? [];
            const drillGroup = drillSmartContent.find(
              (ds: any) => (ds.GroupName ?? ds.groupName) === groupName
            );
            if (drillGroup) {
              return {
                content: drillGroup.Content ?? drillGroup.content,
                drillSmartResult: drillGroup.DrillSmartResult ?? drillGroup.drillSmartResult,
                drillSmartLaunchUrl: drillGroup.LaunchUrl ?? drillGroup.launchUrl,
                groupName: drillGroup.GroupName ?? drillGroup.groupName,
                nextDrill: drillGroup.NextDrill ?? drillGroup.nextDrill,
              };
            }
          }
        }
        return null;
      });
    });
  };

  const rawData = drillSmart?.modalState?.data;
  const drillSmartModalData: DrillSmartModalData | null =
    rawData != null && rawData !== "" ? (rawData as DrillSmartModalData) : null;

  return (
    <>
      {exams && Array.isArray(exams) && exams.length > 5 ? (
        <DrillPaginationTab
          exams={exams}
          theme={theme}
          type={type}
          settoggleUnlockModal={settoggleUnlockModal}
          handlePrimaryBtnClick={handlePrimaryButtonClick}
          handleSecondaryBtnClick={handleSecondaryButtonClick}
        />
      ) : (
      exams &&
        Array.isArray(exams) &&
        exams.length > 0 &&
        exams.map((value: any, index: number) => {
          const rowDisplay = getRowDisplayForWork(value, {
            formatDateCompleted: (d) => formatToLocalDate(d, "MM/DD/YYYY"),
          });
          return (
            <div className="course-index-class-home-container" key={index}>
              <CourseIndexHomeWorkRow
                index={index}
                textIconLabel={rowDisplay.textIconLabel}
                iconType={rowDisplay.iconType}
                middleLabel={rowDisplay.middleLabel}
                badge={rowDisplay.badge || undefined}
                handlePrimaryBtnClick={() => handlePrimaryButtonClick(value)}
                handleSecondaryBtnClick={() => handleSecondaryButtonClick(value)}
                theme={theme}
                isLocked={value.IsLocked}
                status={rowDisplay.status}
                contentObjectType={rowDisplay.contentObjectType}
                drillSmartResult={rowDisplay.drillSmartResult}
              />
            </div>
          );
        }) ) }
      <RefreshModal
        handleOnClose={handleModalClose}
        contentObjectType={refreshModalStatus.contentObjectType}
        isOpen={refreshModalStatus.isOpen}
        theme={theme}
        handleRefresh={handleRefreshCourseIndex}
        isFetching={
          refetchCourseIndexIsResult.isFetching ||
          courseWorkIsFetching ||
          overAllProgressIsFetching ||
          studyPlannerRefetchResult.isFetching ||
          testScoresIsFetching ||
          aiRecommendationRefetchResult.isFetching
        }
      />
        

      <DrillSmartModal
        handleOnClose={drillSmart.closeModal}
        isOpen={drillSmart.modalState.isOpen}
        theme={theme}
        data={drillSmartModalData}
        onStartDrill={getDrillSmartOnStartDrill(
          drillSmartModalData,
          (contentType) => {
            handleSetCourseworkPage();
            setRefreshModalStatus((prev) => ({ ...prev, isOpen: true, contentObjectType: contentType || "Test" }));
          },
          openExternalUrl,
          dispatch,
          testtype
        )}
      />
      <DrillModal
        handleUpdateModalClose={handleUpdateModalClose}
        openUpdateModalState={openUpdateModalState}
        refetchData={handleRefreshCourseIndex}
        theme={theme}
        isFetchingOtherAPIs={
          refetchCourseIndexIsResult.isFetching ||
          courseWorkIsFetching ||
          overAllProgressIsFetching ||
          studyPlannerRefetchResult.isFetching ||
          testScoresIsFetching ||
          aiRecommendationRefetchResult.isFetching
        }
      />
      <UnlockModal
        handleUnlockModalClose={() => settoggleUnlockModal(false)}
        handleUpgrade={handleUpgradeCourse}
        unlockModalState={toggleUnlockModal}
        theme={theme}
      />
      {/* ScoreReportModal now rendered globally in App.tsx */}
    </>
  );
};
